<template>
  <v-container class="video none-fluid link">
    <banner>Videos</banner>
    <div class="video-content mx-auto">
      <div>
        <v-row justify="space-between">
          <v-col v-for="(video,i) in videos" :key="i" cols="12" lg="6">
            <div v-html="video.video"></div>
<!--            <h4>{{ video.order }}</h4>-->
            <p v-html="$sanitize(video.description)"></p>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getAllVideos } from "../../service/media/video";
import Banner from "../global/Banner";

export default {
  data() {
    return {
      panels: [],
      videos: [],
    };
  },
  mounted() {
    // get all movies
    getAllVideos()
      .then((videos) => {
        this.videos = videos;
        for (let i = 0; i < videos.length; ++i) {
          this.panels.push(i);
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  components: {
    Banner,
  },
};
</script>

<style lang="scss">
.video {
  h4 {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  iframe {
    //width: 100%;
    //height: 260px;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
  .video {
    h4 {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    iframe {
      width: 100%;
      height: 260px;
    }
  }
}
</style>
